module.exports = __webpack_public_path__ + "img/connect-5.70a592b3.svg";